import { useMemo } from 'react';
import {
  CoachListStore,
  nutritionCoachListStore,
  scanIQCoachListStore,
} from '../../../stores/coachListStore';
import { COACH_LIST_MODE, CoachListMode } from '../NgzCoachList.settings';

export const useCoachListStore = (mode: CoachListMode): CoachListStore => {
  if (!mode) {
    throw new Error('useCoachListStore: mode is required');
  }

  const stores: Record<CoachListMode, CoachListStore> = {
    [COACH_LIST_MODE.NUTRITION]: nutritionCoachListStore,
    [COACH_LIST_MODE.SCAN_IQ]: scanIQCoachListStore,
  };

  return useMemo(() => {
    return stores[mode];
  }, [mode]);
};
